
/* eslint-disable */

import "./IE-classlist";
import "./IE-foreach";
import "./IE-hypot";
import "./IE-remove";
import "whatwg-fetch";

require("es6-promise").polyfill();
